import { render } from "./AddEditCategoryModal.vue?vue&type=template&id=d7123ec8&scoped=true"
import script from "./AddEditCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddEditCategoryModal.vue?vue&type=script&lang=js"

import "./AddEditCategoryModal.vue?vue&type=style&index=0&id=d7123ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7123ec8"]])

export default __exports__